module.exports = __webpack_public_path__ + "static/media/Howard Ave, Burlingame, CA1.3f3ce70e.jpg";